import {
  CustomerAreaDataTestIds,
  CustomerAreaRoutes,
} from '@backoffice-frontend/common'
import { useCustomerSearchV2Warmup } from '@backoffice-frontend/customer-api'
import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { UsersIcon } from '@moia-dev/pace-icons'

export const CustomerAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  const triggerWarmup = useCustomerSearchV2Warmup()

  const handleClick = () => {
    triggerWarmup()
    onClick?.()
  }

  return (
    <NavigationItem
      onClick={handleClick}
      dataTestId={CustomerAreaDataTestIds.Navigation}
      Icon={UsersIcon}
      label={label}
      open={open}
      to={CustomerAreaRoutes.route}
    />
  )
}
